import { Dispatch, SetStateAction, useState } from 'react';
import { QueryKey, UseQueryResult, useQuery } from 'react-query';

import { GetDocumentsWithStructure } from '@pimm/services/lib/sms-documents/services';
import { Category, GetWithStructureRequest } from '@pimm/services/lib/sms-documents';

export const useGetDocumentStructure = (props?: {
  queryKey?: string;
  query?: GetWithStructureRequest;
}): [UseQueryResult<Category[]>, Dispatch<SetStateAction<GetWithStructureRequest>>] => {
  const [query, setQuery] = useState<GetWithStructureRequest>({
    ...props?.query,
  });

  const categories = useQuery({
    enabled: !!query?.brandId && !!query.marketId,
    queryKey: [props?.queryKey ?? 'GetDocumentsWithStructure', query] as [QueryKey, GetWithStructureRequest],
    queryFn: ({ queryKey }) => {
      return GetDocumentsWithStructure(queryKey[1]);
    },
  });
  return [categories, setQuery];
};
